import React, { useCallback, useEffect, useRef, useState } from 'react';

import { getBadgeStyles } from './styles';

export default function VersionBadge() {
  const [positionY, setPositionY] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const isDraggingRef = useRef(false);
  const badgeRef = useRef<HTMLDivElement>(null);

  const tag = process.env.NEXT_PUBLIC_GIT_TAG || 'Unknown';
  const isQA =
    process.env.NODE_ENV === 'development' ||
    process.env.NEXT_PUBLIC_APP_ENV === 'qa' ||
    tag.toLowerCase().includes('qa');

  const updatePosition = useCallback((clientY: number) => {
    const newY = (clientY / window.innerHeight) * 100;
    setPositionY(Math.min(Math.max(newY, 5), 95));
  }, []);

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (!isDraggingRef.current) return;
      e.preventDefault();
      updatePosition(e.clientY);
    },
    [updatePosition]
  );

  const handleTouchMove = useCallback(
    (e: TouchEvent) => {
      if (!isDraggingRef.current) return;
      e.preventDefault();
      updatePosition(e.touches[0].clientY);
    },
    [updatePosition]
  );

  const handleDragEnd = useCallback(() => {
    isDraggingRef.current = false;
    setIsDragging(false);
  }, []);

  const handlePointerDown = (e: React.PointerEvent) => {
    e.preventDefault();
    isDraggingRef.current = true;
    setIsDragging(true);
  };

  const handleTouchStart = () => {
    isDraggingRef.current = true;
    setIsDragging(true);
  };

  useEffect(() => {
    window.addEventListener('pointermove', handleMouseMove);
    window.addEventListener('pointerup', handleDragEnd);
    window.addEventListener('touchmove', handleTouchMove, { passive: false });
    window.addEventListener('touchend', handleDragEnd);

    return () => {
      window.removeEventListener('pointermove', handleMouseMove);
      window.removeEventListener('pointerup', handleDragEnd);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleDragEnd);
    };
  }, [handleMouseMove, handleTouchMove, handleDragEnd]);

  if (!isQA) return null;

  return (
    <div
      ref={badgeRef}
      onPointerDown={handlePointerDown}
      onTouchStart={handleTouchStart}
      style={getBadgeStyles(positionY, isDragging)}
      title="Drag to reposition"
    >
      {tag}
    </div>
  );
}
